import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'camelToLabel',
  standalone: false,
})
export class CamelToLabelPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return '';
    }

    return (
      value
        // Step 1: Insert space before uppercase letters (camelCase handling)
        .replace(/([a-z])([A-Z])/g, '$1 $2')

        // Step 2: Insert space before numbers
        .replace(/([a-zA-Z])(\d)/g, '$1 $2')

        // Step 3: Insert space after numbers before letters
        .replace(/(\d)([a-zA-Z])/g, '$1 $2')

        // Step 4: Handle underscores and dashes
        .replace(/[_-]/g, ' ')

        // Step 5: Split into words and process each word
        .split(' ')
        .map((word) => {
          // Convert to lowercase first, then capitalize first letter
          return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        })
        .join(' ')

        // Step 6: Clean up extra spaces
        .replace(/\s+/g, ' ')
        .trim()
    );
  }
}
